import { render, staticRenderFns } from "./MultiswitchDouble.vue?vue&type=template&id=95343622&scoped=true&"
import script from "./MultiswitchDouble.vue?vue&type=script&lang=js&"
export * from "./MultiswitchDouble.vue?vue&type=script&lang=js&"
import style0 from "./MultiswitchDouble.vue?vue&type=style&index=0&id=95343622&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95343622",
  null
  
)

export default component.exports